Pegasus.OverlayController = Ember.Controller.extend({
  isEditing: false,
  opaque: false
});
